module.exports = __webpack_public_path__ + "img/icon_map_102_on.a5a81a49.png";